<template>
  <div>
    <div v-if="$store.state.login.isLogging">
      <van-row type="flex" justify="center">
        <h4>登录</h4>
      </van-row>
      <br />
      <br />
    </div>
  </div>
</template>

<script>
import { CellGroup, Col, Icon, Row, Toast } from "vant";

export default {
  name: "login",
  components: {
    [Row.name]: Row,
    [Col.name]: Col,
    [Icon.name]: Icon,
    [CellGroup.name]: CellGroup,
    [Toast.name]: Toast
  },
  mounted() {
    let code = this.$route.query.code;
    let to = this.$route.query.state;
    if (code === undefined) {
      this.$store.dispatch("login_login", to);
      return;
    }
    this.$store.dispatch("login_wechatLoginWithCode", { code, to });
  }
};
</script>

<style scoped></style>
